import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Container from "../components/Container";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import banner1 from "../assets/acer/AcerPredatorHeliosNeo16.jpeg";
import banner2 from "../assets/apple/AppleMacbookProA2442.jpg";
import banner3 from "../assets/asus/AsusTUFGamingA15.jpg";
import banner4 from "../assets/dell/DellLatitude5430.jpeg";
import banner5 from "../assets/hp/HPElitebook1040G9.jpeg";
import banner6 from "../assets/lenovo/LenovoIdeapadV14G3.jpg";
import banner7 from "../assets/msi/MSIBravo15.jpg";
import acer from "../assets/brand/acer1.png";
import apple from "../assets/brand/apple.png";
import asus from "../assets/brand/Asus.png";
import dell from "../assets/brand/Dell.png";
import hp from "../assets/brand/Hp.png";
import lenovo from "../assets/brand/Lenovo.png";
import msi from "../assets/brand/msi.png";
import reviewBg from "../assets/review_bg.jpg";

export default function Home() {
  const currentUrl = typeof window !== "undefined" ? window.location.href : "https://www.credibletech.in";
  const navigate = useNavigate();
  const banners = [banner1, banner2, banner3, banner4, banner5, banner6, banner7 ];

  const brands = [
    { name: "Apple", image: apple, path: "/refurbished-laptops/apple", color: "from-red-400 to-pink-500" },
    { name: "Dell", image: dell, path: "/refurbished-laptops/dell", color: "from-blue-400 to-blue-600" },
    { name: "HP", image: hp, path: "/refurbished-laptops/hp", color: "from-green-400 to-green-600" },
    { name: "Lenovo", image: lenovo, path: "/refurbished-laptops/lenovo", color: "from-yellow-400 to-yellow-600" },
    { name: "Asus", image: asus, path: "/refurbished-laptops/asus", color: "from-purple-400 to-purple-600" },
    { name: "MSI", image: msi, path: "/refurbished-laptops/msi", color: "from-indigo-400 to-indigo-600" },
    { name: "Acer", image: acer, path: "/refurbished-laptops/acer", color: "from-orange-400 to-orange-600" }
  ];

   const reviews = [
    {
      name: "Sandeep J",
      location: "Bengaluru",
      text: "First of all, it is one of the best shop to sell ur laptop and buy laptop at affordable cost!! Shop owner will guide through the entire process smoothly!! I sold and bought a laptop from this shop! It's really good!! I really appreciate it!! Thank you credible technologies!.",
    },
    {
      name: "Aruneash Paulraj",
      location: "salem",
      text: "Great Assist in Service and Also sold my Asus laptop for a good price.Customer Service on Point👍Responds immediately to Calls and queries.If looking for a used laptop can get for a good deal! Got Macbook pro for a best deal✨Kudos to Imthiaz Mohideen for swift and friendly assist!!!",
    },
    {
      name: "kandasamy MeenakshiSundaram",
      location: "Bengaluru",
      text: "I recently visited Credible Technologies, a fantastic store for computer peripherals, iand had an awesome experience. From the moment I walked in, the owner himself greeted me warmly and was super helpful. He explained everything about the drawing pen tablet I was interested in, breaking down all the features so I could easily understand. He even set up a demo for me to try it out right there in the store. Their prices were better than other online vendors, which was a pleasant surprise. Plus, my tablet was delivered to me really quickly. When I had an issue with a faulty piece, they immediately replaced it without any questions asked. Credible Technologies truly excels in customer support and satisfaction. Their friendly nature, detailed product explanations, willingness to offer demos, competitive pricing, and fast delivery make them a top choice for anyone looking for computer peripherals. I highly recommend them and will definitely be back for future purchases. Rating: ⭐⭐⭐⭐⭐",
    },
    {
      name: "Dzo 22",
      location: "Hyderabad",
      text: "I had a great experience at Credible technologies Shop.. THE owner and staff was very helpful, and they guided me well in choosing the right laptop. First of all, the shop stocks a range of high range of high quality computers, laptops and other electronics accessories. I purchased MacBook Pro 💻 am so glad that I found this shop near my home .macbook pro it's working really good. They have really maintained the laptops really great . Must visit u if looking for good laptops or gaming equipment.",
    },
    {
      name: "Naziya Khan",
      location: "jayanagr",
      text: "I had bought a Laptop for my daughter for online classes from Credible Technologies.Good Customer service and Mr. Imtiaz had suggested good options within a reasonable budget for my requirements, very much satisfied with his utmost focus on customer needs.",
    },
    {
      name: "Vanu Malai",
      location: "Bangalore",
      text: "Good service nd delivery Reliable products are used for replacement of hardwares , charges are reasonable one Very good person nd honest in work🙏1 ",
    },
    {
      name: "Basharath KHAN",
      location: "Btm",
      text: "Very humble and nice person. Very good quality and genuine systems. Owner is a very honest person. Keep up the good work",
    },
    {
      name: "SUMIT KUMAR JHA",
      location: "Bangalore",
      text: "Very good experience. Service is flawless. Wide range of Products are available on very decent price.",
    },
    {
      name: "Rajesh Kumar",
      location: "Bangalore",
      text: "I've purchased recently to this store..the customer service has been excellent..very pleased with the store.",
    },
    {
      name: "Harshad Bagde",
      location: "Jayanagar",
      text: "I had flickering issues on my Lenovo laptop. Since 6 months now the issue is been resolved. Thanks credible technology",
    },
  ];

  const [animate, setAnimate] = useState(false);
  const [current, setCurrent] = useState(0);
  const carouselRef = useRef(null);
  const reviewRef = useRef(null);

  useEffect(() => setAnimate(true), []);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % banners.length);
        setAnimate(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        carouselRef.current.scrollLeft += 1;
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth / 2) {
          carouselRef.current.scrollLeft = 0;
        }
      }
    }, 20);
    return () => clearInterval(scrollInterval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (reviewRef.current) {
        reviewRef.current.scrollLeft += 1;
        if (reviewRef.current.scrollLeft >= reviewRef.current.scrollWidth / 2) {
          reviewRef.current.scrollLeft = 0;
        }
      }
    }, 30);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>Refurbished Laptops in Bangalore | Laptop Repair & Buyback | Credible Technologies</title>
        <meta
          name="description"
          content="Buy premium refurbished laptops, get expert laptop repair, and sell your old laptop in Bangalore. Trusted by thousands. Visit Credible Technologies today!"
        />
        <meta
          name="keywords"
          content="refurbished laptops, laptop repair, sell old laptop, buyback, credible technologies, bangalore, used laptops, laptop service, corporate laptops, gaming laptops, office laptops, student laptops, rental laptops"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content="Refurbished Laptops in Bangalore | Credible Technologies" />
        <meta
          property="og:description"
          content="Buy premium refurbished laptops, get expert laptop repair, and sell your old laptop in Bangalore. Trusted by thousands. Visit Credible Technologies today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.credibletech.in/assets/newlogo1.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Refurbished Laptops in Bangalore | Credible Technologies" />
        <meta
          name="twitter:description"
          content="Buy premium refurbished laptops, get expert laptop repair, and sell your old laptop in Bangalore. Trusted by thousands. Visit Credible Technologies today!"
        />
        <meta name="twitter:image" content="https://www.credibletech.in/assets/newlogo1.png" />
      </Helmet>

      {/* HERO SECTION */}
      <section className="min-h-screen bg-gradient-to-br from-black via-slate-900 to-black text-white flex items-center">
        <Container>
          <div className="grid md:grid-cols-12 gap-8 items-center w-full">
            <div
              className={`md:col-span-5 order-1 transition-all duration-700 ease-out mt-16 sm:mt-0 ${
                animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
            >
              <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-tight">
                Credible Technologies Refurbished <br />
                <span className="text-blue-500">Laptop Store</span>
              </h1>
              <p className="mt-6 text-base sm:text-lg md:text-xl text-slate-300 max-w-full sm:max-w-lg">
                Buy certified refurbished & gaming laptops with warranty, genuine parts, and expert support in Bangalore.
              </p>
              <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-4">
                <a
                  href="#buy-laptop"
                  className="bg-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition text-center"
                >
                  View Products
                </a>

                <Link
                  to="/contactus#form"
                  className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-black transition text-center"
                >
                  Contact Us
                </Link>
              </div>
            </div>

            <div className="md:col-span-7 order-2 relative h-64 sm:h-80 md:h-[500px] overflow-hidden rounded-xl">
              {banners.map((img, index) => (
                <div
                  key={index}
                  className={`absolute top-0 left-0 w-full h-full transition-all duration-700 ease-out ${
                    index === current ? (animate ? "opacity-100 scale-100 z-10" : "opacity-0 scale-95 z-10") : "opacity-0 scale-95 z-0"
                  }`}
                >
                  <img src={img} alt={`Banner ${index + 1}`} className="w-full h-full object-cover drop-shadow-2xl rounded-xl" />
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* Trusted Laptop Repair Section */}
      <section className="bg-white py-16 sm:py-20">
        <Container>
          <div className="w-full max-w-4xl mx-auto text-center">
            <div className="w-16 h-1 bg-blue-600 mb-6 mx-auto"></div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 leading-tight">
              Bangalore’s Trusted Laptop Repair Experts – Based in Jayanagar
            </h2>
            <p className="mt-4 sm:mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              Welcome to <span className="font-semibold text-slate-900">Credible Technologies</span> – your go-to destination for expert laptop repair and maintenance services in Jayanagar, Bangalore.
            </p>
            <p className="mt-2 sm:mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              From cracked screens and battery issues to software bugs and hardware failures – <span className="font-semibold text-slate-900">Credible Technologies</span> is here to provide fast, affordable, and reliable service you can trust.
            </p>
          </div>
        </Container>
      </section>

      {/*Buy laptop Section */}
      <section id="buy-laptop" className="py-16 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">Buy Used & Refurbished Laptop</h2>
          <p className="text-gray-600 mb-8 sm:mb-12 text-base sm:text-lg md:text-xl">Upgrade affordably with our quality refurbished laptops. Explore options now!</p>
          <div ref={carouselRef} className="flex gap-4 sm:gap-6 overflow-x-auto overflow-x-hidden overflow-y-hidden scrollbar-hide py-4">
            {brands.concat(brands).map((brand, index) => (
              <div
                key={index}
                onClick={() => navigate(brand.path)}
                className={`flex flex-col items-center justify-between p-4 sm:p-6 rounded-3xl shadow-lg transform transition-transform duration-500 cursor-pointer bg-gradient-to-br ${brand.color} hover:scale-105 hover:shadow-2xl`}
                style={{ minWidth: "180px", maxWidth: "260px", height: "280px", flexShrink: 0 }}
              >
                <div className="flex-1 flex items-center justify-center">
                  <img src={brand.image} alt={brand.name} className="max-w-full max-h-32 sm:max-h-44 object-contain rounded-lg" />
                </div>
                <p className="mt-2 sm:mt-4 text-white font-bold text-base sm:text-lg md:text-xl">{brand.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sell Your Laptop Section */}
      <section className="relative bg-gradient-to-r from-blue-600 to-indigo-700 py-20 sm:py-28 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-48 h-48 sm:w-72 sm:h-72 bg-blue-400/30 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-indigo-400/30 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl animate-pulse"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center text-white">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4 sm:mb-6 animate-fadeIn">
            Sell Your Used Laptop Instantly
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-12 max-w-3xl mx-auto animate-fadeIn delay-200">
            Get top value for your laptop with quick assessment, secure pickup, and instant payment. Transform your old device into cash today!
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 mb-12 animate-fadeIn delay-400">
            <a
              href="https://wa.me/919538577199?text=I%20want%20to%20sell%20my%20laptop"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-white/90 to-white/70 text-blue-700 font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition duration-300"
            >
              Check Price
            </a>
            <a
              href="https://wa.me/919538577199?text=Hello%2C%20I%20need%20to%20sell%20my%20laptop.%20Can%20you%20schedule%20a%20pickup%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-white hover:text-blue-700 transition duration-300"
            >
              Schedule Pickup
            </a>

          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8 max-w-4xl mx-auto animate-fadeIn delay-600">
            <div className="bg-white/20 backdrop-blur-md p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition text-center">
              <img src="https://cdn-icons-png.flaticon.com/512/2910/2910764.png" alt="Price" className="w-10 h-10 sm:w-14 sm:h-14 mx-auto mb-2 sm:mb-4 animate-bounce" />
              <h3 className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Fast Price Check</h3>
              <p className="text-xs sm:text-sm">Know the worth of your laptop in minutes, instantly!</p>
            </div>
            <div className="bg-white/20 backdrop-blur-md p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition text-center">
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Cash" className="w-10 h-10 sm:w-14 sm:h-14 mx-auto mb-2 sm:mb-4 animate-bounce" />
              <h3 className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Instant Payment</h3>
              <p className="text-xs sm:text-sm">Choose UPI, bank transfer, or cheque — get paid fast!</p>
            </div>
            <div className="bg-white/20 backdrop-blur-md p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition text-center">
              <img src="https://cdn-icons-png.flaticon.com/512/2910/2910754.png" alt="Pickup" className="w-10 h-10 sm:w-14 sm:h-14 mx-auto mb-2 sm:mb-4 animate-bounce" />
              <h3 className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Safe Pickup</h3>
              <p className="text-xs sm:text-sm">Our team collects your laptop safely and securely from your doorstep.</p>
            </div>
          </div>

          <div className="absolute -top-16 right-4 sm:right-10 w-24 sm:w-40 animate-floatLaptop hidden md:block">
            <img src="https://cdn-icons-png.flaticon.com/512/565/565547.png" alt="Laptop" className="w-full" />
          </div>
        </div>
      </section>

      {/* Laptop Services Section */}
      <section className="py-16 sm:py-20 bg-gray-50">
        <Container>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">Laptop Services</h2>
          <p className="text-gray-600 text-center mb-8 sm:mb-12 text-base sm:text-lg md:text-xl">
            Your one-stop solution for all laptop needs - buy, sell, or repair with confidence
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 text-blue-500">💵</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 text-gray-900">Sell Used Laptop</h3>
              <p className="text-gray-600 mb-4 text-sm sm:text-base">
                Get the best price for your used laptop. Quick evaluation and instant payment.
              </p>
              <button
                onClick={() =>
                  window.open(
                    "https://wa.me/919538577199?text=Hello%2C%20I%20am%20interested%20in%20selling%20my%20laptop.%20Please%20guide%20me%20with%20the%20next%20steps.",
                    "_blank"
                  )
                }
                className="bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
              >
                Sell Now
              </button>

            </div>
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 text-blue-500">💻</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 text-gray-900">Buy Used Laptop</h3>
              <p className="text-gray-600 mb-4 text-sm sm:text-base">
                Find quality refurbished laptops at unbeatable prices. All devices tested and certified.
              </p>
              <button
                onClick={() =>
                  window.open(
                    "https://wa.me/919538577199?text=Hello%2C%20I%20am%20interested%20in%20buying%20a%20laptop.%20Please%20share%20the%20available%20options%20and%20pricing%20details.",
                    "_blank"
                  )
                }
                className="bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
              >
                Buy Now
              </button>

            </div>
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 text-blue-500">🛠️</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 text-gray-900">Repair Laptop</h3>
              <p className="text-gray-600 mb-4 text-sm sm:text-base">
                Professional laptop repair services. Fast turnaround with genuine parts and warranty.
              </p>
              <button
                onClick={() =>
                  window.open(
                    "https://wa.me/919538577199?text=Hello%2C%20I%20would%20like%20to%20book%20a%20laptop%20repair%20service.%20Please%20let%20me%20know%20the%20next%20steps.",
                    "_blank"
                  )
                }
                className="bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
              >
                Book Repair
              </button>
            </div>
          </div>
        </Container>
      </section>
      
      {/* How It Works Section */}
      <section className="py-16 sm:py-20 bg-white">
        <Container>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">How it Works?</h2>
          <p className="text-gray-600 text-center mb-8 sm:mb-12 text-base sm:text-lg md:text-xl">
            Sell Your Used Laptop In Just 3 Easy Steps
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-gradient-to-tr from-blue-500 to-indigo-600 p-6 sm:p-8 rounded-2xl text-white shadow-lg hover:scale-105 transform transition duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">📦</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">Check Price</h3>
              <p className="text-sm sm:text-base">
                Discover the worth of your laptop with a quick assessment. Enter your device details now for an instant price evaluation.
              </p>
            </div>
            <div className="bg-gradient-to-tr from-green-400 to-teal-500 p-6 sm:p-8 rounded-2xl text-white shadow-lg hover:scale-105 transform transition duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">📅</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">Schedule Meeting</h3>
              <p className="text-sm sm:text-base">
                Schedule a convenient meeting time for your laptop. Our team will handle the rest, ensuring a seamless selling experience.
              </p>
            </div>
            <div className="bg-gradient-to-tr from-pink-500 to-red-500 p-6 sm:p-8 rounded-2xl text-white shadow-lg hover:scale-105 transform transition duration-300 text-center">
              <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">💰</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">Get Paid</h3>
              <p className="text-sm sm:text-base">
                Select your preferred payment method: UPI, bank transfer, or cheque. Receive your payment promptly once your laptop is received and evaluated.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Reviews Section */}
      <section
        className="py-16 sm:py-20 relative"
        style={{
          backgroundImage: `url(${reviewBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
        <Container>
          <div className="relative z-10 text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
              Trusted by thousands of happy users since 2017
            </h2>
          </div>

          <div
            ref={reviewRef}
            className="flex gap-4 sm:gap-6 overflow-x-auto overflow-x-hidden overflow-y-hidden scrollbar-hide py-4"
          >
            {reviews.concat(reviews).map((review, index) => (
              <div
                key={index}
                className="min-w-[300px] max-w-[300px] sm:min-w-[320px] sm:max-w-[320px] bg-gray-50/50 p-4 sm:p-6 rounded-2xl shadow-md hover:scale-105 transform transition-all duration-300 flex-shrink-0"
              >
                <h3 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">
                  {review.name}
                </h3>

                {/* Location */}
                {review.location && (
                  <p className="text-black text-xs font-semibold sm:text-sm mb-2">
                    {review.location}
                  </p>
                )}

                {/* Review Text with max 7 lines */}
                <p className="text-gray-800 text-xs sm:text-sm leading-snug line-clamp-7 overflow-hidden h-[8.75rem]">
                  {review.text}
                </p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Our Services Section */}
      <section className="py-16 sm:py-24 bg-white">
        <Container>
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">Our Services</h2>
            <p className="text-gray-600 mt-2 sm:mt-3 text-base sm:text-lg md:text-xl">Professional laptop repair solutions with guaranteed results</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {[
              {
                title: "Logic Board Repair",
                icon: "🧠",
                desc: "Expert component-level motherboard diagnostics and repair with precision micro-soldering.",
              },
              {
                title: "Liquid Damage",
                icon: "💧",
                desc: "Professional recovery from water and liquid exposure using ultrasonic cleaning.",
              },
              {
                title: "Screen Replacement",
                icon: "🖥️",
                desc: "High-quality LCD/LED screen replacement with perfect color calibration.",
              },
              {
                title: "Battery Replacement",
                icon: "🔋",
                desc: "Restore battery life with premium cells matching original capacity.",
              },
              {
                title: "Speaker Repair",
                icon: "🔊",
                desc: "Fix audio issues and replace damaged speakers for crystal clear sound.",
              },
              {
                title: "Touchpad Repair",
                icon: "🖱️",
                desc: "Repair or replace malfunctioning touchpads for smooth control.",
              },
              {
                title: "Flexgate Repair",
                icon: "🧩",
                desc: "Specialized display cable repair for modern laptops.",
              },
              {
                title: "Keyboard Repair",
                icon: "⌨️",
                desc: "Fix sticky keys or replace damaged keyboards with premium components.",
              },
            ].map((service, index) => {
              const phone = "919538577199";
              const message = `Hello, I would like to schedule a repair service for ${service.title}. Please guide me with the next steps.`;
              const encodedMessage = encodeURIComponent(message);

              return (
                <div
                  key={index}
                  className="group bg-gray-50 rounded-2xl p-4 sm:p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-500"
                >
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-xl bg-blue-50 text-blue-600 text-2xl sm:text-3xl mb-3 sm:mb-5 group-hover:scale-110 transition">
                    {service.icon}
                  </div>

                  <h3 className="text-sm sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">
                    {service.title}
                  </h3>

                  <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                    {service.desc}
                  </p>

                  <button
                    onClick={() =>
                      window.open(
                        `https://wa.me/${phone}?text=${encodedMessage}`,
                        "_blank"
                      )
                    }
                    className="text-xs sm:text-sm font-semibold text-blue-600 hover:text-blue-700 transition flex items-center gap-1 sm:gap-2"
                  >
                    Schedule Repair →
                  </button>
                </div>
              );
            })}
          </div>

        </Container>
      </section>
    </>
  );
}